import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { AssignFulfillmentServiceActionStep } from "@redotech/redo-flows-common/oms/actions";
import { FulfillmentService } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoOutboundLabelsRpcClientContext } from "@redotech/redo-merchant-fulfillment-app/outbound-labels-rpc-client";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";
import { PartialWithRequiredType } from ".";

export const FulfillmentServiceDropdown = memo(
  function FulfillmentServiceDropdown({
    step,
    setStep,
  }: {
    step: PartialWithRequiredType<AssignFulfillmentServiceActionStep>;
    setStep: (
      step: PartialWithRequiredType<AssignFulfillmentServiceActionStep>,
    ) => void;
  }) {
    const rpcClient = useRequiredContext(RedoOutboundLabelsRpcClientContext);
    const team = useRequiredContext(TeamContext);

    const fulfillmentServiceLoad = useLoad(
      async (signal) => {
        try {
          const { fulfillmentServices } =
            await rpcClient.getFulfillmentServiceForTeam({}, { signal });
          const services: FulfillmentService[] = [];

          if (team) {
            services.push({ name: team.name ?? "", _id: team._id });
          }

          services.push(...fulfillmentServices);
          return services;
        } catch (error) {
          console.error(error);
          return [];
        }
      },
      [team],
    );

    const listItems: RedoListItem<FulfillmentService>[] = useMemo(() => {
      return (
        fulfillmentServiceLoad.value?.map((fulfillmentService) => ({
          id: fulfillmentService._id,
          value: fulfillmentService,
          type: "text",
          text: fulfillmentService.name,
        })) || []
      );
    }, [fulfillmentServiceLoad.value]);

    return (
      <RedoSingleSelectDropdownInput
        options={listItems}
        optionSelected={(option) => {
          const newStep = {
            ...step,
            fulfillmentServiceId: option.item.value._id,
            fulfillmentServiceName: option.item.value.name,
          };
          setStep(newStep);
        }}
        selectedItem={listItems.find(
          (item) => item.value._id === step.fulfillmentServiceId,
        )}
      />
    );
  },
);
